export default __webpack_public_path__ + "static/media/SOTD_3.7e4a1eec.png";